import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './SuccessPage.css';

const SuccessPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  
  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      try {
        const sessionId = new URLSearchParams(location.search).get('session_id');
        if (!sessionId) {
          setError('No session ID found');
          setLoading(false);
          return;
        }

        await new Promise(resolve => setTimeout(resolve, 3000));
        setLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setError(error.message);
        setLoading(false);
      }
    };

    checkSubscriptionStatus();
  }, [location]);

  if (loading) {
    return (
      <div className="container">
        <div className="card">
          <div className="emoji">⏳</div>
          <h2>Setting up your subscription</h2>
          <p>Just a moment while we confirm your payment...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <div className="card">
          <div className="emoji">⚠️</div>
          <h2>Oops! Something went wrong</h2>
          <p>{error}</p>
          <button 
            onClick={() => window.location.href = '/support'}
            className="support-button"
          >
            Contact Support
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <div className="emoji">✨</div>
        <h2>You're all set!</h2>
        <p>Your subscription is now active. You can return to the app and continue using all premium features.</p>
      </div>
    </div>
  );
};

export default SuccessPage;